import React from 'react';
import { CheckIcon } from 'lucide-react';
import { CTAButton } from '../CTAButton';
import { HERO_MOCKUP } from '../../data/content';
type Props = {
  ctaRef: React.RefObject<HTMLDivElement>;
};
const badges = ['6 Premium Volumes', '5 Professional Bonuses', '30+ Protocols, Checklists & Tools'];
export function Hero({
  ctaRef
}: Props) {
  return <header className="w-full bg-navy-900 pb-10 pt-8 sm:pb-16 sm:pt-12" data-id="element-189" data-mp="hsutykvw1qhe">
      <div className="mx-auto w-full max-w-5xl px-4" data-id="element-190" data-mp="mtiubx60bjoa">
        <div className="flex flex-col items-center text-center" data-id="element-191" data-mp="qvduuzg45t10">
          <p className="inline-flex items-center gap-2 rounded-full border border-white/15 px-3 py-1.5 text-[10px] font-extrabold uppercase tracking-[0.18em] text-sky-400 sm:text-xs" data-id="element-192" data-mp="qtj7zfla7qua">
            🦷 The clinical control system for aligner treatments
          </p>

          <h1 className="mt-5 font-display text-[30px] font-black uppercase leading-[1.05] tracking-tight text-white sm:text-5xl lg:text-6xl" data-id="element-193" data-mp="15ll6av7pebs7">
            Organize any aligner case in{' '}
            <span className="text-sky-400" data-id="element-194" data-mp="9oubs4omfa05">less than 15 minutes</span>
          </h1>

          <p className="mt-4 max-w-2xl text-base leading-relaxed text-navy-100 sm:text-lg" data-id="element-195" data-mp="4o6lxmc4oz7i">
            Stop jumping between courses, notes, PDFs, and different resources
            every time you need to review an aligner case. Get a step-by-step
            system for assessment, planning, and control.
          </p>

          <img src={HERO_MOCKUP} alt="ALIGNER CONTROL SYSTEM: six volumes, five bonuses and printable clinical tools" className="mt-6 w-full max-w-2xl sm:mt-8" width={1080} height={1080} data-id="element-196" data-mp="sd94cwel6w32" />

          <ul className="mb-6 flex w-full flex-col gap-2 sm:flex-row sm:justify-center sm:gap-3" data-id="element-197" data-mp="en5lmfex1kid">
            {badges.map(badge => <li key={badge} className="flex items-center justify-center gap-2 rounded-xl bg-white/[0.07] px-3 py-2 text-sm font-bold text-white" data-id="element-198" data-mp="1b5to9ocb5quq">
                <CheckIcon className="h-4 w-4 shrink-0 text-sky-400" aria-hidden="true" data-id="element-199" data-mp="30myrem7ibbi4" />
                {badge}
              </li>)}
          </ul>

          <div ref={ctaRef} className="flex w-full justify-center" data-id="element-200" data-mp="2qvkwysuex1vu">
            <CTAButton label="Get Aligner Control System™" subline="Instant digital access · One-time payment of $27 · Lifetime access · 7-day guarantee" data-id="element-201" data-mp="2vufdfo4wqecs" />
          </div>
        </div>
      </div>
    </header>;
}